'use client';

import { useEffect } from 'react';
import { getLocalStorageSizeMB } from 'src/utils/localStorageUtils';
import { TV_TRADES_CACHE_STORAGE_KEY } from 'src/components/TradingView/TvAppTradeDataManager';

const LOCAL_STORAGE_SIZE_THRESHOLD_MB = 3; // the maximum size of localStorage is 5MB, we set the threshold to 3MB in case some large data takes up more than 2MB in one "setItem" run

/**
 * Cleans up large localStorage entries on app mount.
 * Removes tv_trades_cache_v1 if localStorage size exceeds threshold, since its the biggest culprit of localStorage size bloat.
 */
const useCleanupLargeLocalStorage = () => {
	useEffect(() => {
		if (typeof window === 'undefined') return;

		const sizeMB = getLocalStorageSizeMB();
		if (sizeMB > LOCAL_STORAGE_SIZE_THRESHOLD_MB) {
			localStorage.removeItem(TV_TRADES_CACHE_STORAGE_KEY);
		}
	}, []);
};

export default useCleanupLargeLocalStorage;
